import { useConfig } from 'hooks/use-config';
import { useAuthStore } from '../state/store/auth/useAuthStore';
import { useNotificationStore } from '../state/store/common/useNotificationStore';
import { subscribeNotifications } from '@seliseblocks/notifications';
import { useRef } from 'react';

export function useNotification(reconnectOnTimeout = false) {
  console.log("useNotification hook called", reconnectOnTimeout);
  const { configurationSettings } = useConfig();


  const previousTokenRef = useRef<string | null>(null);
  const wasConnectedRef = useRef<boolean>(false);
  const accessTokenFactory = () => {
    const token = useAuthStore.getState().accessToken;
    return token ? token : '';
  };
  const { handleNotification } =
    useNotificationStore();
  const disconnect = useRef<(() => Promise<void>) | null>(null);
  const apiBaseUrl = `https://${configurationSettings.paths.baseUrl}/notification/v1`;
  const projectKey = configurationSettings.blocksKey;
  const token = useAuthStore.getState().accessToken;

  const connect = async () => {
    if (!token) {
      console.warn('Cannot connect to notification service: No access token available');
      wasConnectedRef.current = false;
      previousTokenRef.current = null;
      return;
    }
    const tokenChanged = previousTokenRef.current !== null && previousTokenRef.current !== token;
    if (token && (tokenChanged || !wasConnectedRef.current)) {
      previousTokenRef.current = token;
      wasConnectedRef.current = true;
      const { stop } = await subscribeNotifications(
        apiBaseUrl,
        {
          projectKey,
          configSize: 100,
          accessTokenFactory,
        },
        handleNotification
      );
      disconnect.current = stop;
      // try {

      //   if (reconnectOnTimeout) {
      //     const lastTime = lastConnectionTime();
      //     const currentTime = Date.now();
      //     if (lastTime && currentTime - lastTime > reconnectTimeoutInMinutes * 60 * 1000) {
      //       // console.log('Reconnecting to notification service...');
      //       subscribeNotifications(
      //         apiBaseUrl,
      //         {
      //           projectKey,
      //           configSize: 100,
      //           accessTokenFactory,
      //         },
      //         handleNotification
      //       );
      //       logConnectionTime();
      //     }
      //   } else {
      //     subscribeNotifications(
      //       apiBaseUrl,
      //       {
      //         projectKey,
      //         configSize: 100,
      //         accessTokenFactory,
      //       },
      //       handleNotification
      //     );
      //   }
      // } catch (error) {
      //   console.error("notification Service error:", error);
      // }
    }
  };
  return { connect, disconnect };
}
